import { Form, Select } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import styles from "./_SelectWorkflowModulo.less";
import { useTranslation } from "react-i18next";
import ActionBar from "../../../components/action-bar";
import ActionLink from "../../../components/action-link";

export default function SelectWorkflowModulo(props) {
  const { modulo, onSubmit, readOnly } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [edicao, setEdicao] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const modulos = [
    { id: "societario", label: "Societário" },
    { id: "regulatorio", label: "Regulatório" },
    { id: "compliance", label: "Compliance" },
  ];

  const initialModuloId = modulos.find((m) => m.id === modulo)?.id;

  const fireSubmit = (modulo) => {
    let promise = Promise.resolve();
    if (typeof onSubmit === "function") promise = promise.then(() => onSubmit(modulo));
    return promise;
  };

  const handleClick = (e) => {
    if (readOnly) return;
    e.preventDefault();
    form.resetFields();
    setEdicao(true);
    setSearchValue("");
  };

  const handleFinish = (values) => {
    fireSubmit(values.modulo).then(() => setEdicao(false));
  };

  if (edicao) {
    return (
      <Form form={form} onFinish={handleFinish} size="middle">
        <Form.Item name="modulo" initialValue={initialModuloId} noStyle>
          <Select
            allowClear
            autoFocus
            className={styles["select"]}
            filterOption={false}
            placeholder={t("Módulo")}
            searchValue={searchValue}
            onSearch={setSearchValue}
            showSearch
          >
            {modulos.map((modulo) => (
              <Select.Option key={modulo.id} value={modulo.id}>
                {t(modulo.label)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <ActionBar>
          <ActionLink.Save onClick={form.submit}/>
          <ActionLink.Cancel onClick={() => setEdicao(false)}/>
        </ActionBar>
      </Form>
    );
  }

  let className = styles["workflow-tarefa-modulo"];
  if (!modulo) className += " " + styles["nao-preenchido"];
  if (readOnly) className += " " + styles["read-only"];

  return (
    <div className={className} onClick={handleClick}>
      <div className={styles["descricao"]}>
        {!!modulo ? modulos.find((m) => m.id === modulo)?.label || modulo : t('(não preenchido)')}
      </div>
    </div>
  );
}

SelectWorkflowModulo.propTypes = {
  workflowId: PropTypes.number,
  onSubmit: PropTypes.func,
  onUnload: PropTypes.func,
  readOnly: PropTypes.bool,
};
